var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras1.formBg)?_c('div',{staticClass:"m-wrap-new m-pc",style:({
    background:
      _vm.extras1.formBg.colorOrBg == 'color'
        ? _vm.extras1.formBg.color
        : 'url(' + _vm.extras1.formBg.src + ')',
  })},[(_vm.extras1 && _vm.extras1.formLogo.display == '1')?_c('div',{staticClass:"semianr-logo"},[_c('img',{attrs:{"src":_vm.isSetting != '1'
          ? _vm.extras1.headerLogo && _vm.extras1.headerLogo.src
          : './images/logo_new.png',"alt":""}})]):_vm._e(),(_vm.isSetting != '1')?_c('div',{staticClass:"seminar-info"},[(_vm.extras1 && _vm.extras1.seminarInfo.display == '1')?_c('div',{staticClass:"seminar-info-new",class:_vm.extras1.BannerText.textAlign},[_c('div',{staticClass:"content"},[(_vm.extras1.textSetting.subTitle != 'hide')?_c('div',{staticClass:"seminar-title",style:({
            color:
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.fontColor
                : '',

            'font-style':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.fontWeight == 'on'
                  ? '900'
                  : ''
                : '',
          })},[_vm._v(" "+_vm._s(_vm.extras1.textSetting.text)+" ")]):_vm._e(),(_vm.extras1.textSetting.title != 'hide')?_c('div',{staticClass:"seminar-slogan",style:({
            color:
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.fontColor2
                : '',

            'font-style':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.fontTilt2 == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.fontWeight2 == 'on'
                  ? '900'
                  : ''
                : '',
          })},[_vm._v(" "+_vm._s(_vm.extras1.textSetting.title == "default" ? _vm.seminarInfo.title : _vm.seminarInfo.title)+" ")]):_vm._e(),_c('div',{staticClass:"semianr-time"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extras1.textSetting.timeTitle != 'hide'),expression:"extras1.textSetting.timeTitle != 'hide'"}],staticClass:"_title",style:({
              color:
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.fontColor3
                  : '',
              background: _vm.extras1.textSetting.bgColor5 || '',
              'font-style':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.fontTilt3 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.fontWeight3 == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v(" "+_vm._s(_vm.extras1.textSetting.timeTitle == "custom" ? _vm.extras1.textSetting.text3 : "会议时间")+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extras1.textSetting.time != 'hide'),expression:"extras1.textSetting.time != 'hide'"}],staticClass:"_time",style:({
              color:
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.fontColor4
                  : '',
              background: _vm.extras1.textSetting.bgColor6 || '',
              'font-style':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.fontTilt4 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.fontWeight4 == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v(" "+_vm._s(_vm.handleTimeStamps(_vm.seminarInfo.startTime, _vm.seminarInfo.endTime))+" ")])])])]):_vm._e()]):_vm._e(),(_vm.isSetting == '1')?_c('div',{staticClass:"seminar-info"},[(_vm.extras1 && _vm.extras1.seminarInfo.display == '1')?_c('div',{staticClass:"seminar-info-new"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"seminar-title"},[_vm._v("2023企业数字化峰会")]),_c('div',{staticClass:"seminar-slogan"},[_vm._v("设计连接 新商业")]),_c('div',{staticClass:"semianr-time"},[_c('div',{staticClass:"_title"},[_vm._v(" "+_vm._s("会议时间")+" ")]),_c('div',{staticClass:"_time"},[_vm._v(" "+_vm._s("2023.12.12-12.13")+" ")])])])]):_vm._e()]):_vm._e(),_c('div',{staticClass:"field-area form1",style:({
      background:
        _vm.extras1.formFieldBg.colorOrBg == 'color'
          ? _vm.extras1.formFieldBg.color
          : 'url(' + _vm.extras1.formFieldBg.src + ')',
    })},[_c('vue-scroll',{attrs:{"ops":_vm.ops}},[(_vm.extras1.formTitle.display == 1 && _vm.formInfo.status != 2)?_c('div',{staticClass:"title",class:_vm.extras1.formTitle.textAlign,style:({ 'letter-spacing': _vm.extras1.formTitle.wordWidth + 'px' })},[_vm._v(" "+_vm._s(_vm.extras1.formTitle.title)+" ")]):_vm._e(),(_vm.formInfo.status != 2)?_c('CField',{staticClass:"field-wrap new",attrs:{"formData":_vm.formData,"platform":_vm.platform}}):_vm._e(),(_vm.formInfo.status == 2)?_c('div',{staticStyle:{"position":"absolute","top":"50%","width":"100%","transform":"translateY(-80%)"}},[_c('div',{staticClass:"u-success"},[_c('img',{attrs:{"src":_vm.imgUrlObj[_vm.platform]['over'],"alt":""}})]),_c('div',{staticClass:"split-line"}),_c('div',{staticClass:"title"},[_vm._v("报名已截止！")])]):_vm._e(),(_vm.preview || _vm.formInfo.status == 1)?_c('div',[_c('div',{staticClass:"split-line"}),_c('div',{staticClass:"bottom"},[_c('a-button',{staticClass:"submit",style:({
              width: _vm.extras.submitButton.width + '%',

              color:
                _vm.extras.submitButton.buttonTextStyle == 'custom'
                  ? _vm.extras.submitButton.fontColor
                  : '',

              'font-style':
                _vm.extras.submitButton.buttonTextStyle == 'custom'
                  ? _vm.extras.submitButton.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-weight':
                _vm.extras.submitButton.buttonTextStyle == 'custom'
                  ? _vm.extras.submitButton.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-size':
                _vm.extras.submitButton.buttonTextStyle == 'custom'
                  ? _vm.extras.submitButton.fontSize + 'px'
                  : '',
            }),attrs:{"type":"primary","disabled":_vm.isSubmitting},on:{"click":function($event){return _vm.submit()}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"submitButton.text"))+" ")]),(_vm.extras.seminarButton && _vm.extras.seminarButton.display == 1)?_c('a-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.formInfo.identity == 1),expression:"formInfo.identity == 1"}],staticClass:"btn-default",on:{"click":function($event){return _vm.togoVerifyNew()}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"seminarButton.text"))+" ")]):_vm._e()],1)]):_vm._e()],1)],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }